import PropTypes from 'prop-types'
import React from 'react'

import { SegmentedTabs } from '@/components/ui/SegmentedTabs'

/**
 *
 * UserTabs
 *
 * WARP-939 — switches the Users page between dealer users and WPC users.
 *
 * A segmented control rather than a dropdown: there are exactly two options, both are
 * worth reading at a glance, and switching is the main thing anyone does on this page.
 *
 * The control itself lives in `components/ui/SegmentedTabs`; this only names it.
 */
const UserTabs = ({ activeTab, onChange, panelId, tabs }) => (
  <SegmentedTabs
    activeTab={activeTab}
    ariaLabel="User type"
    onChange={onChange}
    panelId={panelId}
    tabs={tabs}
  />
)

UserTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  panelId: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
}

export default UserTabs
